import { AudioAssets } from "./AudioAssets";
import { BlockAssets } from "./BlockAssets";
import { EntityAssets } from "./EntityAssets";
import { MeshAssets } from "./MeshAssets";
import { SceneAssets } from "./SceneAssets";
import { TextureAssets } from "./TextureAssets";
import { VoxelAssets } from "./VoxelAssets";

export const AssetConstants = [
  ...Object.values(AudioAssets),
  ...Object.values(BlockAssets),
  ...Object.values(EntityAssets),
  ...Object.values(MeshAssets),
  ...Object.values(SceneAssets),
  ...Object.values(TextureAssets),
  ...Object.values(VoxelAssets),
];

export const EntityConstants = [...Object.values(EntityAssets)];

export * from "./AudioAssets";
export * from "./BlockAssets";
export * from "./EntityAssets";
export * from "./MeshAssets";
export * from "./SceneAssets";
export * from "./TextureAssets";
export * from "./VoxelAssets";
